import * as authTypes from 'modules/auth/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import * as types from '../actionTypes';

const initialState = false;

const isDone = () => true;

const resetSlice = () => initialState;

export default createReducer(initialState, {
  [types.APPLICATION_LOADED]: isDone,
  [authTypes.SIGN_OUT_SUCCESS]: resetSlice,
  [authTypes.SIGN_OUT_EMERGENCY]: resetSlice,
});
